import Nullstack from 'nullstack';
export default function IconCategory2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-category-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 4h6v6h-6z"
  }), "   ", Nullstack.element("path", {
    d: "M4 14h6v6h-6z"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "17",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "7",
    r: "3"
  }), " ");
}